export const PUBLIC_IFRAME_MODAL = "iframeModal";
export const PUBLIC_DIV_MODAL = "divModal";

export const MODALS_NAMESPACE_KEY = "modals";
